import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import ReactPlayer from 'react-player/lazy';
export function BackgroundVideo({ backgroundVideo, shouldPlay, }) {
    const [playing, setPlaying] = useState(false);
    const onReady = useCallback(() => {
        setTimeout(() => {
            setPlaying(true);
        }, 500);
    }, []);
    return (_jsx("div", { className: "background-video", children: _jsx(ReactPlayer, { url: backgroundVideo.url, controls: false, width: "100%", height: "100%", style: {
                opacity: playing ? '1' : '0',
                transition: '2s ease-in-out'
            }, onReady: onReady, config: {
                wistia: {
                    options: {
                        fitStrategy: 'cover',
                        endVideoBehavior: 'loop',
                    }
                }
            }, loop: true, playing: shouldPlay, muted: true }) }));
}
